import * as React from 'react';
import {StyleSheet, View, TouchableWithoutFeedback} from 'react-native';
import Styles from '../../Styles';
import AVText from '../AVText';
import Localized from 'src/constants/AppStrings';
import {getDescriber as getSnackDescriber} from 'src/components/screens/sendSnack/descriptor/sendasnack/DescriptorType';
import {RewardCashType} from 'src/types/Rewards';
import AVFormattedCurrency from 'src/components/elements/AVFormattedCurrency';
import AccountStore from 'src/stores/AccountStore';
import {RewardTier} from 'src/types/RewardsModel';
import {getLayoutDescriber} from 'src/components/elements/layoutDescriptor/DescriptorType';
import CashRewardsIcon from 'src/components/img/svg/rewards/CashRewardsIcon';

const {shadowStyles, bodySmallFontSize, bodyLargeFontSize, bottomTabBtnColor} =
  getLayoutDescriber();

type CashRewardTileProps = {
  rewardItem: RewardCashType;
  tier: RewardTier;
  onRewardPress: (item: RewardCashType, pointsRequired: number) => void;
};
const lineHeightMultiplier = 1.14;
export default function CashRewardTile(props: CashRewardTileProps) {
  const {rewardItem, tier, onRewardPress} = props;
  return (
    <TouchableWithoutFeedback
      onPress={() => {
        !tier.isLocked && onRewardPress(rewardItem, tier.pointsRequired);
      }}
    >
      <View
        style={styles.tile}
        accessible
        nativeID="qa_btn_RewardsItem"
        testID="qa_btn_RewardsItem"
      >
        <View
          accessibilityLabel={rewardItem.cashAmount.toString()}
          accessibilityRole="button"
          style={[styles.productItem, tier.isLocked && styles.disabled]}
        >
          <View style={styles.cashIconView}>
            <CashRewardsIcon color={bottomTabBtnColor()} />
          </View>
          <AVText
            numberOfLines={3}
            maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm2}
            style={[
              styles.productName,
              getSnackDescriber()?.snackDetailsBtnFontSTyle(),
            ]}
          >
            <AVFormattedCurrency
              value={rewardItem.cashAmount}
              currency={AccountStore.getCurrency()}
              style={[
                styles.productName,
                getSnackDescriber()?.snackDetailsBtnFontSTyle(),
              ]}
              maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm2}
            />
            {' ' + Localized.Labels.credit}
          </AVText>
        </View>
      </View>
    </TouchableWithoutFeedback>
  );
}
const styles = StyleSheet.create({
  productItem: {
    width: 164,
    height: 170,
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: 12,
    paddingHorizontal: Styles.Spacing.m3 - 4,
    paddingTop: Styles.Spacing.m3,
    paddingBottom: Styles.Spacing.m4,
    borderRadius: Styles.Spacing.m2,
  },
  productName: {
    width: '100%',
    flexGrow: 1,
    textAlign: 'center',
    fontSize: bodySmallFontSize(),
    fontWeight: '700',
    lineHeight: (Styles.Fonts.f1 - 2) * lineHeightMultiplier,
    marginTop: Styles.Spacing.m0,
  },
  price: {
    fontSize: bodyLargeFontSize(),
    fontWeight: '700',
    textAlign: 'center',
    color: bottomTabBtnColor(),
    width: 66,
  },
  cashIconView: {
    width: 68,
    height: 68,
    borderRadius: 34,
    alignItems: 'center',
    justifyContent: 'center',
  },
  tile: {
    flexDirection: 'column',
    alignItems: 'center',
    ...shadowStyles().lightShadow,
    width: 164,
    height: 170,
    justifyContent: 'space-between',
    gap: 12,
    paddingHorizontal: Styles.Spacing.m3 - 4,
    paddingBottom: Styles.Spacing.m4,
    borderRadius: Styles.Spacing.m2 + 2,
  },
  disabled: {
    opacity: 0.6,
  },
});
